
import { PageRequest } from "@/store/shared/entity";
import CreateProductName from "./component/create-product-name.vue";
import EditProductName from "./component/edit-product-name.vue";

import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins, PageResultListMixins,appConst } from "@/lib";

class PageProductNameRequest extends PageRequest {
  name: string;
}

@Component({
  name:"productname.list", //设置页面对应route的名字，以便keepalive进行缓存
  components: { CreateProductName, EditProductName }
})
export default class ProductName extends Mixins(PageResultBaseMixins, PageResultModalMixins, PageResultListMixins) {
  /**
   * section buttons
   */
  sectionButtons = { ...this.addBtn() };

  /**
   * search-page bind data
   */
  data: any = {
    model: new PageProductNameRequest(),
    queryAction: "system/productname/getAll",
    isAutoQuery: true,
    cols: this.columns
  };

  /**
   * table columns
   */
  get columns() {
    return [
      { title: this.L("app.ProductName.Name"), key: "name", tooltip: true },
      { title: this.L("app.ProductName.NameEn"), key: "nameEn", tooltip: true },
          this.$util.render.codeColumn(
        "app.ProductName.Unit",
        "unit",
        () =>
          this.getCodeListByCategory(
            appConst.codeCategory.unit
          ),
        {width: 120}
      ),
      { title: this.L("app.ProductName.Code"), key: "code", tooltip: true },
   
      this.$util.render.actions(this.colButtons)
    ];
  }

  colButtonCheck = (row)=>{
    return !row.isStatic;
  }

  /**
   * table 操作列按钮
   */
  get colButtons(): ActionButtonConfig[] {
    return [
        this.colEditBtnM(row => this.colButtonCheck(row)),
        this.colDeleteBtn(row => this.colButtonCheck(row))
    ];
  }

  /**
   * reset 回调
   */
  reset() {
    this.data.model = new PageProductNameRequest();
  }
}
